export default "__VITE_ASSET__2U66fAOI__"